import { fetchPastPayments } from "../../store/reducers/dashboardSlice/api";
import { gridColumns_PastPayments } from "../../Utils/TableColumnDefs";
import CommonGrid from "../CommonGrid";
import useFetchTableData from "../../useFetchTableData";
const pastPaymentsFilter = [
  { name: "Past Payment Amount", key: "amount", type: "range" },
  { name: "Check Date", key: "check_date", type: "date" },
  { name: "Check Date", key: "check_date", type: "month" },
];

const PastPaymentsTable = ({ className = "" }) => {
  const { data, status, retry } = useFetchTableData(fetchPastPayments, "pastPayments");

  return (
    <CommonGrid
      status={status}
      onRetry={retry}
      className={`past-payments col-sm-6 ${className}`}
      title={"Past Payments"}
      gridColumns={gridColumns_PastPayments}
      columnData={JSON.parse(JSON.stringify(data))}
      filterOption={pastPaymentsFilter}
      tableTotal={[
        "principal",
        "interest",
        "servicingFee",
        "lateCharge",
        "other",
        "amount",
      ]}
      tHeight={"100%"}
    />
  );
};

export default PastPaymentsTable;
